import { endpoints } from './../../../../environments/environment';
import { Limit, LimitTipo } from './../../limits/models/limits';
import { InvestmentOption } from './../models/investmentOption';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { Auth } from './../../../autentication/Auth';
import { FormatPricePipe } from '../../../shared/format-price.pipe';
import { Util } from '../../../utils/util';
import { BaseResult } from '../../../shared/models/base.result.model';
import { LimiteGeralModel, LimiteTipoPeriodo } from '../../limits/models/limits';
import LimitUtil from '../../../utils/limit-utils';

@Injectable()
export class InvestmentsSimulationService {

	investOptions: Array<InvestmentOption>;

	limits: Array<Limit>;

	constructor(private http: HttpClient) { }

	getInvestmentsOptions(value: number): Observable<InvestmentOption[]> {

		return this.http.get(endpoints.investments.simulation +
			value + '/9999').pipe(map((data: any) => {


				if (data.Sucesso && data.Retorno) {
					const FP = new FormatPricePipe();
					this.investOptions = data.Retorno.Papeis.map(item => {

						const newItem = new InvestmentOption();
						newItem.code = item.CodPapel;
						newItem.finalDate = moment(item.DataFinal).format('DD/MM/YYYY');
						newItem.days = item.Dias;
						newItem.description = item.DscPapel;
						newItem.IOF = item.IOF;
						newItem.IR = item.IR;
						newItem.liquid = FP.transform(item.Liquido, false);
						newItem.percIndex = item.PercIndex;
						newItem.yeld = item.Rendimento;
						newItem.rentability = item.Rentabilidade;
						newItem.yearTax = item.TaxaAno;
						newItem.daysTp = item.TpDias;
						newItem.paperTp = item.TpPapel;
						newItem.taxTp = item.TpTaxa;
						newItem.lastCotation = item.UltimaCotacao;
						newItem.mainValue = data.Retorno.VlrPrincipal;
						newItem.grossValue = FP.transform(data.Retorno.VlrPrincipal + item.Rendimento, false);

						return newItem;
					});

				} else {
					this.investOptions = [];
				}

				return this.investOptions;

			}));

	}

	createHeaders(): HttpHeaders {
		return new HttpHeaders({
			'Assinatura-Eletronica': Auth.assinaturaEletronica ? Auth.assinaturaEletronica : '',
			'Identificador': Auth.getInstance().getGUID(),
			'Omni-Token': Auth.passToken ? Auth.passToken : '',
			'Authorization': 'v2',
		});
	}

	doInvestment(investment: InvestmentOption): Observable<any> {
		const defaultHeaders = this.createHeaders();
		if (investment.paperTp === 2) {
			return this.doPosFixedInvestment(investment, defaultHeaders);
		}
		return this.doPreFixedInvestment(investment, defaultHeaders);
	}


	doPreFixedInvestment(investment: InvestmentOption, headers: HttpHeaders): Observable<any> {
		const serviceUrl = endpoints.investments.applicationPreFixed;

		const payload = {
			principalValue: investment.mainValue,
			code: investment.code,
			term: investment.days,
			annualPercentageRate: investment.yearTax,
			rateType: investment.taxTp,
			requestId: Util.generateUUID4(),
		};

		return this.http.post(serviceUrl, payload, { headers }).pipe(map((data: any) => {
			return data;
		}));
	}

	doPosFixedInvestment(investment: InvestmentOption, headers: HttpHeaders): Observable<any> {
		const serviceUrl = endpoints.investments.applicationPosFixed;

		const payload = {
			principalValue: investment.mainValue,
			code: investment.code,
			term: investment.days,
			percentageRate: investment.percIndex,
			requestId: Util.generateUUID4(),
		};

		return this.http.post(serviceUrl, payload, { headers }).pipe(map((data: any) => {
			return data;
		}));
	}

	getDataLimits(): Observable<any[]> {
		return this.http.get<BaseResult<LimiteGeralModel[]>>(`${endpoints.limits.getLimits}?tipoLimite=TODOS`).pipe(
			map((data: BaseResult<LimiteGeralModel[]>) => {
				if (data.Sucesso) {
					const groupedLimits = LimitUtil.groupLimitsByPeriod(data.Retorno);

					this.limits = groupedLimits.map(item => {
						if (item.type === LimitTipo.INVESTIMENTO) {
							const limit = new Limit();
							limit.timeLimit = item.type;
							const FP = new FormatPricePipe();
							limit.timeStart = item.dailyLimit.FaixaHorario.HorarioInicial + 'h' + ' até as ' + item.dailyLimit.FaixaHorario.HorarioFinal + 'h';
							return limit;
						}
					});

					return this.limits;
				}
			}));
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/investments-simulation/investments-simulation.service.ts